


































import { Component, Prop, Vue } from "vue-property-decorator";
import Handle from "@/components/controls/Handle.vue";

export enum Tabs {
  PATCH = "patch",
  PLANT = "plant",
}

@Component({
  components: { Handle },
})
export default class DetailsPanel extends Vue {
  @Prop({ type: String, required: true }) label!: string;
  @Prop({ type: Boolean, required: true }) visible!: boolean;
  @Prop({ type: String, required: true }) tab!: string;
  @Prop({ type: Array, default: () => [] }) enabledTabs!: string[];

  private get allTabs(): string[] {
    return Object.values(Tabs);
  }

  private get style() {
    return {
      visibility: this.visible ? "visible" : "hidden",
      "pointer-events": this.visible ? "auto" : "none",
    };
  }
}
